import { render, staticRenderFns } from "./slot-widget.vue?vue&type=template&id=a965486e&scoped=true&"
import script from "./slot-widget.vue?vue&type=script&lang=js&"
export * from "./slot-widget.vue?vue&type=script&lang=js&"
import style0 from "./slot-widget.vue?vue&type=style&index=0&id=a965486e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a965486e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
